var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("app-side-menu", [
    _c(
      "aside",
      { staticClass: "menu", attrs: { slot: "side-menu" }, slot: "side-menu" },
      [
        _c("p", { staticClass: "menu-label" }, [
          _c("span", { staticClass: "title is-6" }, [_vm._v(" Filters ")]),
          false
            ? _c(
                "button",
                {
                  staticClass: "button is-pulled-right is-small is-turquoise",
                  on: { click: _vm.gotoV1 },
                },
                [
                  _c("span", { staticClass: "icon" }, [
                    _c("i", { staticClass: "mdi mdi-arrow-right" }),
                  ]),
                  _c("span", [_vm._v("V1")]),
                ]
              )
            : _vm._e(),
        ]),
        _c("ul", { staticClass: "menu-list" }, [
          _c("li", [
            _c("div", { staticClass: "field" }, [
              _c("div", { staticClass: "control" }, [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.innerValue.search,
                      expression: "innerValue.search",
                    },
                  ],
                  staticClass: "input is-uppercase",
                  attrs: { type: "text", placeholder: "Search..." },
                  domProps: { value: _vm.innerValue.search },
                  on: {
                    keyup: function ($event) {
                      return _vm.onFilterClick()
                    },
                    input: function ($event) {
                      if ($event.target.composing) return
                      _vm.$set(_vm.innerValue, "search", $event.target.value)
                    },
                  },
                }),
              ]),
              _c("div", { staticClass: "help" }, [
                _vm._v(" Search by "),
                _c("ul", [
                  _c("li", [_vm._v("Quote No.")]),
                  _c("li", [_vm._v("Rego No.")]),
                  _c("li", [_vm._v("Customer Name/Phone")]),
                  _c("li", [_vm._v("Claim No.")]),
                  _c("li", [_vm._v("Car Make/Model.")]),
                  _c("li", [_vm._v("Key No.")]),
                ]),
              ]),
            ]),
            _c(
              "div",
              {
                staticClass: "field",
                on: {
                  focusout: function ($event) {
                    return _vm.onFilterClick()
                  },
                },
              },
              [
                _c("v-date-picker", {
                  attrs: {
                    "is-dark": _vm.$theme.isDark,
                    masks: _vm.formats,
                    "popover.visibility": "focus",
                    attributes: _vm.attrs,
                    locale: _vm.$userInfo.locale,
                    "model-config": { timeAdjust: "00:00:00" },
                    timezone: _vm.$filters.getIanaTimezone(),
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function ({ inputValue, inputEvents }) {
                        return [
                          _c("div", { staticClass: "field" }, [
                            _c(
                              "div",
                              { staticClass: "control has-icons-left" },
                              [
                                _c(
                                  "input",
                                  _vm._g(
                                    {
                                      staticClass: "input",
                                      attrs: {
                                        type: "text",
                                        placeholder: "Date From...",
                                      },
                                      domProps: { value: inputValue },
                                    },
                                    inputEvents
                                  )
                                ),
                                _c(
                                  "span",
                                  { staticClass: "icon is-small is-left" },
                                  [
                                    _c("i", {
                                      staticClass: "mdi mdi-calendar mdi-18px",
                                    }),
                                  ]
                                ),
                              ]
                            ),
                          ]),
                        ]
                      },
                    },
                  ]),
                  model: {
                    value: _vm.selectedFromDate,
                    callback: function ($$v) {
                      _vm.selectedFromDate = $$v
                    },
                    expression: "selectedFromDate",
                  },
                }),
              ],
              1
            ),
            _c(
              "div",
              {
                staticClass: "field",
                on: {
                  focusout: function ($event) {
                    return _vm.onFilterClick()
                  },
                },
              },
              [
                _c("v-date-picker", {
                  attrs: {
                    "is-dark": _vm.$theme.isDark,
                    masks: _vm.formats,
                    "popover-visibility": "focus",
                    attributes: _vm.attrs,
                    locale: _vm.$userInfo.locale,
                    "model-config": { timeAdjust: "23:59:59" },
                    timezone: _vm.$filters.getIanaTimezone(),
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function ({ inputValue, inputEvents }) {
                        return [
                          _c("div", { staticClass: "field" }, [
                            _c(
                              "div",
                              { staticClass: "control has-icons-left" },
                              [
                                _c(
                                  "input",
                                  _vm._g(
                                    {
                                      staticClass: "input",
                                      attrs: {
                                        type: "text",
                                        placeholder: "Date To...",
                                      },
                                      domProps: { value: inputValue },
                                    },
                                    inputEvents
                                  )
                                ),
                                _c(
                                  "span",
                                  { staticClass: "icon is-small is-left" },
                                  [
                                    _c("i", {
                                      staticClass: "mdi mdi-calendar mdi-18px",
                                    }),
                                  ]
                                ),
                              ]
                            ),
                          ]),
                        ]
                      },
                    },
                  ]),
                  model: {
                    value: _vm.selectedToDate,
                    callback: function ($$v) {
                      _vm.selectedToDate = $$v
                    },
                    expression: "selectedToDate",
                  },
                }),
              ],
              1
            ),
            _vm.insurers
              ? _c("div", { staticClass: "field" }, [
                  _c(
                    "div",
                    { staticClass: "control is-expanded" },
                    [
                      _c(
                        "multiselect",
                        {
                          attrs: {
                            "track-by": "assetId",
                            label: "assetName",
                            placeholder: "Select an insurer",
                            options: _vm.insurers,
                            loading: _vm.isInsurerLoading,
                            "internal-search": false,
                            "options-limit": _vm.insurerFilter.pageSize,
                            searchable: true,
                            "show-labels": false,
                            "allow-empty": true,
                          },
                          on: {
                            select: _vm.selectInsurer,
                            remove: _vm.removeInsurer,
                            "search-change": _vm.getListComboInsurersFiltered,
                          },
                          model: {
                            value: _vm.selectedInsurer,
                            callback: function ($$v) {
                              _vm.selectedInsurer = $$v
                            },
                            expression: "selectedInsurer",
                          },
                        },
                        [
                          _c(
                            "span",
                            {
                              staticClass: "has-text-danger",
                              attrs: { slot: "noResult" },
                              slot: "noResult",
                            },
                            [_vm._v("Insurer not found.")]
                          ),
                        ]
                      ),
                    ],
                    1
                  ),
                ])
              : _vm._e(),
            _c("div", { staticClass: "field" }, [
              _c("div", { staticClass: "control" }, [
                _c("div", { staticClass: "select is-fullwidth" }, [
                  _c(
                    "select",
                    {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.innerValue.authorisedStatus,
                          expression: "innerValue.authorisedStatus",
                        },
                      ],
                      on: {
                        change: [
                          function ($event) {
                            var $$selectedVal = Array.prototype.filter
                              .call($event.target.options, function (o) {
                                return o.selected
                              })
                              .map(function (o) {
                                var val = "_value" in o ? o._value : o.value
                                return val
                              })
                            _vm.$set(
                              _vm.innerValue,
                              "authorisedStatus",
                              $event.target.multiple
                                ? $$selectedVal
                                : $$selectedVal[0]
                            )
                          },
                          function ($event) {
                            return _vm.onFilterClick()
                          },
                        ],
                      },
                    },
                    [
                      _c("option", { attrs: { value: "B" } }, [
                        _vm._v("-- Auth Status --"),
                      ]),
                      _c("option", { attrs: { value: "A" } }, [
                        _vm._v("Authorised"),
                      ]),
                      _c("option", { attrs: { value: "U" } }, [
                        _vm._v("Not Authorised"),
                      ]),
                    ]
                  ),
                ]),
              ]),
            ]),
            _c("div", { staticClass: "field" }, [
              _c("div", { staticClass: "control" }, [
                _c("div", { staticClass: "select is-fullwidth" }, [
                  _c(
                    "select",
                    {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.innerValue.invoiceStatus,
                          expression: "innerValue.invoiceStatus",
                        },
                      ],
                      on: {
                        change: [
                          function ($event) {
                            var $$selectedVal = Array.prototype.filter
                              .call($event.target.options, function (o) {
                                return o.selected
                              })
                              .map(function (o) {
                                var val = "_value" in o ? o._value : o.value
                                return val
                              })
                            _vm.$set(
                              _vm.innerValue,
                              "invoiceStatus",
                              $event.target.multiple
                                ? $$selectedVal
                                : $$selectedVal[0]
                            )
                          },
                          function ($event) {
                            return _vm.onFilterClick()
                          },
                        ],
                      },
                    },
                    [
                      _c("option", { attrs: { value: "A" } }, [
                        _vm._v("-- Inv. Status --"),
                      ]),
                      _c("option", { attrs: { value: "I" } }, [
                        _vm._v("Invoiced"),
                      ]),
                      _c("option", { attrs: { value: "U" } }, [
                        _vm._v("Not Invoiced"),
                      ]),
                      _c("option", { attrs: { value: "P" } }, [
                        _vm._v("Partially Invoiced"),
                      ]),
                    ]
                  ),
                ]),
              ]),
            ]),
            _vm.jobStagesObj
              ? _c("div", { staticClass: "field" }, [
                  _c(
                    "div",
                    { staticClass: "field multi-job-stage-select" },
                    [
                      _c("multiselect", {
                        attrs: {
                          options: _vm.jobStagesObj,
                          "hide-selected": true,
                          multiple: true,
                          "close-on-select": false,
                          "show-labels": false,
                          "clear-on-select": true,
                          "preserve-search": true,
                          placeholder: "Select Job Stages",
                          label: "description",
                          "track-by": "key",
                          taggable: true,
                        },
                        on: {
                          select: _vm.onJobStageSelect,
                          remove: function ($event) {
                            return _vm.onFilterClick()
                          },
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "option",
                              fn: function (props) {
                                return [
                                  props.option.isGroupHeader
                                    ? _c(
                                        "div",
                                        {
                                          staticClass: "job-stage-group-header",
                                        },
                                        [
                                          _vm._v(
                                            " " +
                                              _vm._s(props.option.description) +
                                              " "
                                          ),
                                        ]
                                      )
                                    : _c(
                                        "div",
                                        {
                                          class: {
                                            "job-stage-sub-option":
                                              props.option.hasParentGroup,
                                          },
                                        },
                                        [
                                          _vm._v(
                                            " " +
                                              _vm._s(props.option.description) +
                                              " "
                                          ),
                                        ]
                                      ),
                                ]
                              },
                            },
                          ],
                          null,
                          false,
                          1836707056
                        ),
                        model: {
                          value: _vm.innerValue.jobNSubStage,
                          callback: function ($$v) {
                            _vm.$set(_vm.innerValue, "jobNSubStage", $$v)
                          },
                          expression: "innerValue.jobNSubStage",
                        },
                      }),
                    ],
                    1
                  ),
                ])
              : _vm._e(),
            !!_vm.includeClaimsType
              ? _c("div", { staticClass: "field" }, [
                  _c(
                    "div",
                    { staticClass: "control is-expanded" },
                    [
                      _c(
                        "multiselect",
                        {
                          attrs: {
                            options: _vm.claimsTypes,
                            "preserve-search": true,
                            "track-by": "key",
                            "internal-search": true,
                            searchable: true,
                            "show-labels": false,
                            placeholder: "Select Claims type",
                            label: "description",
                            "allow-empty": true,
                          },
                          on: { select: _vm.onClaimsTypeChange },
                          model: {
                            value: _vm.selectedClaimsType,
                            callback: function ($$v) {
                              _vm.selectedClaimsType = $$v
                            },
                            expression: "selectedClaimsType",
                          },
                        },
                        [
                          _c(
                            "span",
                            {
                              staticClass: "has-text-danger",
                              attrs: { slot: "noResult" },
                              slot: "noResult",
                            },
                            [_vm._v("Claims type not found.")]
                          ),
                        ]
                      ),
                    ],
                    1
                  ),
                ])
              : _vm._e(),
            _c("div", { staticClass: "buttons has-addons" }, [
              _c(
                "span",
                {
                  staticClass: "button",
                  class: {
                    "is-primary is-selected": _vm.innerValue.active === 0,
                  },
                  on: {
                    click: function ($event) {
                      return _vm.changeActive(0)
                    },
                  },
                },
                [
                  _c("span", { staticClass: "icon is-small" }, [
                    _c("i", { staticClass: "mdi mdi-adjust" }),
                  ]),
                  _c("span", [_vm._v("Both")]),
                ]
              ),
              _c(
                "span",
                {
                  staticClass: "button",
                  class: {
                    "is-success is-selected": _vm.innerValue.active === 1,
                  },
                  on: {
                    click: function ($event) {
                      return _vm.changeActive(1)
                    },
                  },
                },
                [
                  _c("span", { staticClass: "icon is-small" }, [
                    _c("i", { staticClass: "mdi mdi-check" }),
                  ]),
                  _c("span", [_vm._v("Active")]),
                ]
              ),
              _c(
                "span",
                {
                  staticClass: "button",
                  class: {
                    "is-danger is-selected": _vm.innerValue.active === 2,
                  },
                  on: {
                    click: function ($event) {
                      return _vm.changeActive(2)
                    },
                  },
                },
                [
                  _c("span", { staticClass: "icon is-small" }, [
                    _c("i", { staticClass: "mdi mdi-close" }),
                  ]),
                  _c("span", [_vm._v("In-Active")]),
                ]
              ),
            ]),
          ]),
        ]),
        _c("hr"),
        _c("div", { staticClass: "field is-grouped is-pulled-right" }, [
          _c("p", { staticClass: "control" }, [
            _c(
              "button",
              {
                staticClass: "button is-primary",
                on: { click: _vm.onFilterClick },
              },
              [
                _c("span", { staticClass: "icon" }, [
                  _c("i", { staticClass: "mdi mdi-magnify mdi-18px" }),
                ]),
                _c("span", [_vm._v("Filter")]),
              ]
            ),
          ]),
          _c("p", { staticClass: "control" }, [
            _c(
              "button",
              { staticClass: "button", on: { click: _vm.onResetClick } },
              [
                _c("span", { staticClass: "icon" }, [
                  _c("i", { staticClass: "mdi mdi-refresh mdi-18px" }),
                ]),
                _c("span", [_vm._v("Reset")]),
              ]
            ),
          ]),
        ]),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }